import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { PriceInsightsListItem } from "../../insights.types";
import { requestProductPriceInsight } from "./productPriceInsigth.request";

const useProductPriceInsight = (
  productId?: string,
  options?: QueryOptions<PriceInsightsListItem, ApiServiceError<ApiError>>
) => {
  const { data: productPriceInsight, ...rest } = useQuery({
    queryKey: ["products", "with-price-insights", "one", productId],
    queryFn: async () => {
      return await requestProductPriceInsight(String(productId));
    },
    enabled: !!productId,
    ...options
  });

  return { productPriceInsight, ...rest };
};

export default useProductPriceInsight;
